export const userTypes = {
    dme: "DME",
    hospice: "Hospice",
    portal: "Portal",
}